import { cva } from '@/styled-system/css';

export const labeledControlRecipe = cva({
  base: {
    'display': 'flex',
    'gap': 'tighter',

    '& > [data-c11n-component="Checkbox"], & > [data-c11n-component="Radio"]': {
      flexShrink: '0',
      marginBlockStart: 'tight',
    },

    '& > [data-c11n-component="Switch.Root"]': {
      flexShrink: '0',
      marginBlockStart: 'LabeledControl.padding.vert.switch.md',
    },

    '& > [data-c11n-component="Label"]': {
      paddingBlock: 'LabeledControl.padding.vert.label',
      textStyle: 'body',
    },

    '& > [data-c11n-component="Label"]:after': {
      content: 'none',
    },
  },
  variants: {
    fluid: {
      true: {
        justifyContent: 'space-between',
      },
      false: {},
    },
    labelPosition: {
      right: {},
      left: {
        '& > [data-c11n-component="Label"]': {
          order: '-1',
        },
      },
    },
    size: {
      md: {},
      lg: {
        '& > [data-c11n-component="Switch.Root"]': {
          marginBlockStart: 'LabeledControl.padding.vert.switch.lg',
        },
      },
    },
  },
});
